import React, { FC } from 'react'
import Grid from '@sport1/react-elements/Grid'
import Touchable from '@sport1/react-elements/Touchable'
import FontelloIcon from '@sport1/react-elements/FontelloIcon'
import { NavigationDateFilterProps } from '../NavigationDateFilterProps'
import { TestID } from '../../utils/PropTypesDefinitions'
import SmallBodyFont from '../../Theme/Fonts/SmallBody'

const NavigationDate: FC<NavigationDateFilterProps & TestID> = ({ label, onDatePress, testID }) => (
    <Grid noExpand height="100%" center backgroundColor="pearl" paddingX={5} borderRadius={4}>
        <Touchable onPress={onDatePress} testID={testID && `${testID}_date_touchable`}>
            <Grid noExpand horizontal center>
                <SmallBodyFont bold numberOfLines={1} testID={testID && `${testID}_label_text`}>
                    {label}
                </SmallBodyFont>
                <FontelloIcon
                    name="dropdown-arrow-active"
                    color="keshi-3"
                    paddingLeft={1}
                    paddingBottom={1}
                />
            </Grid>
        </Touchable>
    </Grid>
)

export default NavigationDate
